import { getCreateTeamsURL } from 'sales-content-partitioning/lib/Links';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const TeamsZeroState = () => {
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "salesContentPartitioning.teamsZeroStateV2.title_jsx",
    options: {
      href: getCreateTeamsURL()
    },
    elements: {
      Link
    }
  });
};
export default TeamsZeroState;